import React, { useState, useEffect } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../../Admin/AdmMain";
import Page from "../../../Atomic/template/PageTable";

//@ts-ignore
import axios from "../../../../lib/axios";
//@ts-ignore
import { useAuth } from "../../../../context/LoginContext.jsx";
//@ts-ignore
import TableAtom from "../../../Atomic/organism/AtomTable";
import { filterData, inputChnage } from "../../../Atomic/exFunc";
import CommonControl from "../../../Atomic/organism/CommonControl";
import Form from "../../../Atomic/organism/FormAtom";
import moment from "moment";

//@ts-ignore
export default function Table() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);

  const [rawData, setRawData] = useState<any>([]);
  const { user } = useAuth();
  const inputRef = React.createRef<HTMLInputElement>();
  const [keyword, setKeyword] = useState("");
  const [data, setData] = useState<any>([]);
  // Function defines
  //===============================================================

  function move(e: any) {
    return;
  }

  function submitFun(e: any) {
    e.preventDefault();
    filterData(rawData, keyword, setData);
  }

  // Data define
  //===============================================================

  const columns: any = [
    {
      header: language === "KOR" ? "번호" : "Num",
      name: "rowKey" + 1,
      width: 50,
      align: "center",
      formatter: (name: any) => name.row.rowKey + 1,
    },
    {
      header: language === "KOR" ? "대상" : "Device",
      name: "unit_nm",
      align: "center",
    },
    {
      header: language === "KOR" ? "취득경로" : "Acquire path",
      name: "path",
      align: "center",
    },
    {
      header: language === "KOR" ? "제공서비스" : "Provision service",
      name: "service",
      align: "center",
    },
    {
      header: language === "KOR" ? "제공받는자" : "Provision user",
      name: "org_nm",
      align: "center",
    },
    {
      header: language === "KOR" ? "위치정보수집일시" : "Acquire date",
      name: "makedate",
      align: "center",
      formatter: (e: any) =>
        moment(e.value).utc().format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      width: 80,
      header: language === "KOR" ? "조직고유값" : "Org code",
      name: "org_idx",
      align: "center",
      sortable: true,
    },
    {
      header: language === "KOR" ? "단말기 번호" : "Device num.",
      name: "unitid",
      align: "center",
    },
    {
      width: 100,
      header: language === "KOR" ? "이벤트 상태" : "Event status",
      name: "event_code",
      align: "center",
    },
    {
      width: 70,
      header: language === "KOR" ? "gps 상태" : "GPS status",
      name: "gps_status",
      align: "center",
      formatter: (e: any) => (e.value === "V" ? "음영" : "양호"),
    },
    {
      width: 70,
      header: language === "KOR" ? "gps 개수" : "GPS cnt",
      name: "gps_sv",
      align: "center",
    },
  ];

  const formData = {
    lan: language,
    inputId: "keyword",
    type: "text",
    placeKR: "검색어를 입력하세요",
    placeEN: "Please enter a search term",
    submitHandler: submitFun,
    filter: (e: any) => inputChnage(e, rawData, setData, setKeyword),
    myref: inputRef,
    value: keyword,
  };

  const buttonData = [
    {
      labelKR: "전체목록",
      labelEN: "View All",
      classN: "white",
      clickFun: () => {
        setKeyword("");
      },
      position: "left",
      icon: false,
      iconClass: "",
    },
  ];
  // useEffect define
  //===============================================================

  useEffect(() => {
    axios
      .get(`/web/admin/prov/list?type=${user.type}`)
      .then((res: any) => {
        if (res?.data) {
          // setRawData(res.data);
          setRawData([]);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [user]);

  useEffect(() => {
    if (rawData && keyword === "") {
      setData(rawData);
    } else if (rawData && keyword !== "") {
      filterData(rawData, keyword, setData);
    }
  }, [rawData, keyword]);

  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "위치정보이용·제공사실" : "Usage Log of location information"}`}
        menu="/Adm/liu-log"
      >
        <Form formData={formData} inputRef={inputRef} />
        <TableAtom data={data} columns={columns} move={move} />
        <CommonControl buttonData={buttonData} language={language} />
      </Page>
    </>
  );
}
